import styled, { css } from 'styled-components';

export const Container = styled.label<{ $isDisabled?: boolean }>`
  /* Estilo checkbox plano: solo input + texto label asociado.
     SIN borde / background / padding tipo botón. */
  display: inline-flex;
  align-items: center;
  /* Alinear el toggle con el bottom absoluto del row (mismo nivel que
     los iconos de ContainerButtons, que también usa align-self: flex-end).
     Sin padding-bottom — cualquier separación inferior empuja el toggle
     hacia arriba y lo desalinea con los iconos. */
  align-self: flex-end;
  gap: 0.6rem;
  cursor: pointer;
  font-size: ${({ theme }) => theme.fontSize.XS};
  user-select: none;
  color: ${({ theme }) => theme.colors.black};

  ${({ $isDisabled }) =>
    $isDisabled &&
    css`
      cursor: not-allowed;
      opacity: 0.6;
    `}
`;

export const Checkbox = styled.input.attrs({ type: 'checkbox' })`
  width: 1.4rem;
  height: 1.4rem;
  cursor: pointer;
  accent-color: ${({ theme }) => theme.colors.garnet};
`;

export const Label = styled.span`
  white-space: nowrap;
`;
